import { Link } from "react-router-dom";
import { categories } from "@/mocks/gossip";
import SectionHeading from "@/components/base/SectionHeading";

export default function CategoryStrip() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100" aria-labelledby="category-heading">
      <SectionHeading
        kicker="Topic Lines"
        title="按内容线找瓜，分类清楚不迷路"
        desc="六条常驻内容线覆盖娱乐、网红、影视、音乐、电竞与时尚。每条线都按时间顺序归档，方便你顺着线索往回看。"
        linkTo="/topics"
        linkLabel="查看全部专题"
      />
      <h2 id="category-heading" className="sr-only">
        内容线分类
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {categories.map((item) => (
          <Link
            key={item.id}
            to={`/hot?category=${item.id}`}
            className="group flex flex-col gap-3 p-4 md:p-5 bg-background-50 border border-background-200 rounded-lg hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className="w-11 h-11 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center text-xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={item.icon}></i>
            </span>
            <span className="font-heading text-base font-semibold text-foreground-950">{item.name}</span>
            <span className="text-xs text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</span>
            <span className="mt-auto text-[11px] font-label text-secondary-700 inline-flex items-center gap-1">
              <i className="ri-folder-3-line"></i>
              {item.count} 条瓜料
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}